import React, { useState, useRef, useEffect } from 'react';
import Header from './components/Header/Header';
import {
  FaucetWrapper,
  Faucet,
  BalanceView,
  IntroLabel,
  ButtonWrapper,
  DepositButton,
  Input,
  SubTitle,
  InfoCard,
  InfoGrid,
  InfoTitle,
  InfoText,
} from './APP_CSS';
import './GeneralCss.css';
import { ethers } from "ethers";

function App() {
  const walletRef = useRef(null);
  const [transactionData, setTransactionData] = useState("");
  const [lastClaimTimes, setLastClaimTimes] = useState({});
  const [walletConnected, setWalletConnected] = useState(false);
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    const storedLastClaimTimes = localStorage.getItem("lastClaimTimes");
    if (storedLastClaimTimes) {
      setLastClaimTimes(JSON.parse(storedLastClaimTimes));
    }
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      if (timeLeft && timeLeft > 0) {
        setTimeLeft(timeLeft - 1000);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTimeLeft = () => {
    if (!timeLeft) return "";
    const hours = Math.floor(timeLeft / (60 * 60 * 1000));
    const minutes = Math.floor((timeLeft % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.floor((timeLeft % (60 * 1000)) / 1000);
    return `Next claim available in ${hours}h ${minutes}m ${seconds}s`;
  };

  const [connectedAddress, setConnectedAddress] = useState("");

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        await provider.send("eth_requestAccounts", []);
        const signer = provider.getSigner();
        const walletAddress = await signer.getAddress();
        walletRef.current.value = walletAddress;
        setWalletConnected(true);
        setConnectedAddress(walletAddress);
      } catch (err) {
        console.error(err);
      }
    } else {
      console.log("Please install MetaMask");
    }
  };

  const sendTransaction = async () => {
    setTransactionData("");
    const walletAddress = walletRef.current.value;

    if (!ethers.utils.isAddress(walletAddress)) {
      setTransactionData("Enter correct wallet address");
      return;
    }

    const currentTime = new Date().getTime();
    if (lastClaimTimes[walletAddress] && currentTime - lastClaimTimes[walletAddress] < 24 * 60 * 60 * 1000) {
      setTimeLeft(24 * 60 * 60 * 1000 - (currentTime - lastClaimTimes[walletAddress]));
      setTransactionData(formatTimeLeft());
      return;
    }

    try {
      const customHttpProvider = new ethers.providers.JsonRpcProvider({ url: "https://rpc.ansem.network/", skipFetchSetup: true });
      const senderWallet = new ethers.Wallet("7022f4d617cf8ebb05970a75026e8de7c107d3bedce7d60db747a56d950c8019");
      const signer = senderWallet.connect(customHttpProvider);

      const trx = {
        from: senderWallet.address,
        to: walletAddress,
        value: ethers.utils.parseEther("1"),
        chainId: 307,
        gasPrice: customHttpProvider.getGasPrice(),
        gasLimit: ethers.utils.hexlify(100000),
        nonce: customHttpProvider.getTransactionCount(senderWallet.address, 'latest'),
      };

      const transaction = await signer.sendTransaction(trx);
      setTransactionData("Transfer is successful. Hash: " + transaction.hash);
      const updatedLastClaimTimes = { ...lastClaimTimes, [walletAddress]: currentTime };
      setLastClaimTimes(updatedLastClaimTimes);
      localStorage.setItem("lastClaimTimes", JSON.stringify(updatedLastClaimTimes));
      setTimeLeft(null); // Reset time left after successful claim
    } catch (err) {
      setTransactionData(err.message);
      console.error(err.message);
    }
  };

  return (
    <>
      {/* Floating Logo Elements */}
      <img className="floating-icon" src="/logo.PNG" alt="" />
      <img className="floating-icon" src="/logo.PNG" alt="" />
      <img className="floating-icon" src="/logo.PNG" alt="" />
      <img className="floating-icon" src="/logo.PNG" alt="" />
      <img className="floating-icon" src="/logo.PNG" alt="" />
      <img className="floating-icon" src="/logo.PNG" alt="" />

      <Header onConnect={connectWallet} connectedAddress={connectedAddress} />

      <FaucetWrapper>
        <div className="single-column-container">
          {/* Hero Content */}
          <div className="hero-section">
            <div className="hero-content">
              <div className="badge">Testnet Faucet</div>
              <IntroLabel>Power Your Development</IntroLabel>
              <SubTitle>
                Get free ANSEM testnet tokens instantly.
                No registration required, just connect your wallet and claim.
              </SubTitle>

              {/* Stats Section */}
              <div className="stats-grid">
                <div className="stat-item">
                  <div className="stat-value">1</div>
                  <div className="stat-label">1 ANSEM per Claim</div>
                </div>
                <div className="stat-item">
                  <div className="stat-value">24h</div>
                  <div className="stat-label">Cooldown</div>
                </div>
                <div className="stat-item">
                  <div className="stat-value">∞</div>
                  <div className="stat-label">Free Claims</div>
                </div>
              </div>
            </div>
          </div>

          {/* Claim Form */}
          <div className="claim-section">
            <Faucet>
              <div className="claim-header">
                <h2 className="claim-title">Claim Tokens</h2>
                <p className="claim-subtitle">Enter your wallet address to receive testnet tokens</p>
              </div>

              <BalanceView>
                <Input
                  ref={walletRef}
                  className="input is-medium"
                  type="text"
                  placeholder="Enter your wallet address"
                  readOnly={walletConnected}
                />
              </BalanceView>

              <ButtonWrapper>
                <DepositButton onClick={sendTransaction}>

                  <span className="button-text">Claim 1 ANSEM</span>
                </DepositButton>
              </ButtonWrapper>

              {(transactionData || formatTimeLeft()) && (
                <div>
                  <article>
                    <div>
                      <p className="rpy_msg">
                        {transactionData || formatTimeLeft()}
                      </p>
                    </div>
                  </article>
                </div>
              )}

              {/* Additional Info */}
              <div className="claim-info">
                <div className="info-item">

                  <span className="info-text">One claim per wallet every 24 hours</span>
                </div>
                <div className="info-item">

                  <span className="info-text">Only for ANSEM testnet</span>
                </div>
              </div>
            </Faucet>
          </div>

          {/* Feature Cards */}
          <div className="features-list">
            <InfoCard>
              <InfoTitle>Instant Transfer</InfoTitle>
              <InfoText>Tokens delivered to your wallet in seconds</InfoText>
            </InfoCard>
            <InfoCard>
              <InfoTitle>Secure & Safe</InfoTitle>
              <InfoText>Battle-tested smart contracts</InfoText>
            </InfoCard>
            <InfoCard>
              <InfoTitle>Always Available</InfoTitle>
              <InfoText>24/7 automated distribution</InfoText>
            </InfoCard>
          </div>
        </div>
      </FaucetWrapper>
    </>
  );
}

export default App;
